import { render, staticRenderFns } from "./PhotoLibrariesConfig.vue?vue&type=template&id=38ae156f&"
import script from "./PhotoLibrariesConfig.vue?vue&type=script&lang=js&"
export * from "./PhotoLibrariesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports